import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";
import { setLoader } from "./WorkFlowRedux";
import axios from "axios";
import { commonservices } from "../../CommonServices";

export const SubscribersContactGetByPrimaryKey = createAsyncThunk(
  "SubscribersContactGetByPrimaryKey",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "GET",
          url:
            API_URL.BASEURL +
            API_URL.CONTACT_DETAILS +
            `?subscribersContactId=${data}`,
        },
        false
      );
      let response = apiResponse(false, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const SubscribersContactSave = createAsyncThunk(
  "SubscribersContactSave",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.SUBSCRIBERS_CONTACT_SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const SubscribersContactGetList = createAsyncThunk(
  "SubscribersContactGetList",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CONTACT_GETLIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const SubscribersContactResendVerificationMail = createAsyncThunk(
  "SubscribersContactResendVerificationMail",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "GET",
          url: `${API_URL.BASEURL}${API_URL.SUBSCRIBERSCONTACT.RESEND_VERIFICATION_EMAIL}?SubscriberContactId=${data}`,
        },
        false
      );
      let response = apiResponse(true, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const InviteToDeveloper = createAsyncThunk(
  "InviteToDeveloper",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.SUBSCRIBERSCONTACT.INVITETODEVELOPER,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

export const InviteToDataFactory = createAsyncThunk(
  "InviteToDataFactory",
  async (data, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.SUBSCRIBERSCONTACT.INVITETODATAFACTORY,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);
      dispatch(setLoader(false));
      return response;
    } catch (error) {
      dispatch(setLoader(false));
    }
  }
);

const initialState = {
  SubscribersContactGetByPrimaryKeyData: {
    data: null,
    error: null,
  },
  SubscribersContactSaveData: {
    data: null,
    error: null,
  },
  SubscribersContactGetListData: {
    data: null,
    error: null,
  },
  SubscribersContactResendVerificationMailData: {
    data: null,
    error: null,
  },
  InviteToDeveloperData: {
    data: null,
    error: null,
  },
  InviteToDataFactoryData: {
    data: null,
    error: null,
  },
};

const SubscribersContactSlice = createSlice({
  name: "SubscribersContactSlice",
  initialState,
  reducers: {
    // setSubscriberIdData: (state) => {
    //   state.GetSubscriberProfileData.data = null;
    // },
  },

  extraReducers: (builder) => {
    builder
      .addCase(SubscribersContactGetByPrimaryKey.fulfilled, (state, action) => {
        state.SubscribersContactGetByPrimaryKeyData.data = action.payload;
      })
      .addCase(SubscribersContactGetByPrimaryKey.rejected, (state, action) => {
        state.SubscribersContactGetByPrimaryKeyData.error =
          action.error.message;
      })
      .addCase(SubscribersContactSave.fulfilled, (state, action) => {
        state.SubscribersContactSaveData.data = action.payload;
      })
      .addCase(SubscribersContactSave.rejected, (state, action) => {
        state.SubscribersContactSaveData.error = action.error.message;
      })
      .addCase(SubscribersContactGetList.fulfilled, (state, action) => {
        state.SubscribersContactGetListData.data = action.payload;
      })
      .addCase(SubscribersContactGetList.rejected, (state, action) => {
        state.SubscribersContactGetListData.error = action.error.message;
      })
      .addCase(
        SubscribersContactResendVerificationMail.fulfilled,
        (state, action) => {
          state.SubscribersContactResendVerificationMailData.data =
            action.payload;
        }
      )
      .addCase(
        SubscribersContactResendVerificationMail.rejected,
        (state, action) => {
          state.SubscribersContactResendVerificationMailData.error =
            action.error.message;
        }
      )
      .addCase(InviteToDeveloper.fulfilled, (state, action) => {
        state.InviteToDeveloperData.data = action.payload;
      })
      .addCase(InviteToDeveloper.rejected, (state, action) => {
        state.InviteToDeveloperData.error = action.error.message;
      })
      .addCase(InviteToDataFactory.fulfilled, (state, action) => {
        state.InviteToDataFactoryData.data = action.payload;
      })
      .addCase(InviteToDataFactory.rejected, (state, action) => {
        state.InviteToDataFactoryData.error = action.error.message;
      });
  },
});

// export const { setSubscriberIdData } = SubscribersContactSliceSlice.actions;
export default SubscribersContactSlice.reducer;
